<template>
  <ul class="file-list">
    <li v-for="(file, i) in files" :key="file[keyVal]">
      {{ file[keyVal] }}
      <button
        type="button"
        :aria-label="tStatic('removeFile')"
        @click="$emit('delete', i)">
        x
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      required: true
    },
    keyVal: {
      type: String,
      default: 'name'
    }
  }

}
</script>

<style lang="scss">
.file-list {
  @include reset-list
}

.file-list>*:not(:last-child) {
  margin-bottom: measure(eighth);
}

.file-list li {
  @include caption-bold;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: measure(quarter);
  background-color: color(blue-4);
  border-radius: other(border-radius);
}

.file-list li:hover {
  background-color: color(blue-3);
}

.file-list li button {
  @include reset-button;
}

.file-list li button::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

</style>
